import { useState } from "react";
import { Link } from "../lib/router";
import { copy } from "../content/copy";
import { usePopStore } from "../state/usePopStore";

/**
 * The page a shared link lands on. The card shown here is the very same PNG the
 * Worker hands to crawlers, so what a visitor sees is exactly what was posted.
 */
export default function SharePage({ popNumber }: { popNumber: number }) {
  const [copied, setCopied] = useState(false);
  const url = typeof location === "undefined" ? "" : `${location.origin}/s/${popNumber}`;
  // Read once, not subscribed: whether this card is the visitor's own memento
  // is settled by the time they land here.
  const isMine = usePopStore.getState().myLastPop === popNumber;
  const myCount = usePopStore.getState().myPopCount;

  const share = async () => {
    const data = { title: `Pop #${popNumber.toLocaleString("en-US")} at Poparium`, url };
    // Native share sheet on mobile; clipboard everywhere else.
    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share(data);
        return;
      } catch {
        /* dismissed — fall through to copying */
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch {
      setCopied(false);
    }
  };

  return (
    <main className="share">
      <p className="kicker">{copy.share.kicker}</p>
      <h1 className="share-title">
        Pop #{popNumber.toLocaleString("en-US")}
      </h1>
      {isMine && (
        <p className="share-yours">
          🎈 {copy.share.yours}
          {myCount > 0 && (
            <span className="share-yours-count">
              {" "}
              {copy.share.yoursCount.replace("{n}", myCount.toLocaleString("en-US"))}
            </span>
          )}
        </p>
      )}
      <p className="share-sub">{copy.share.body}</p>

      <img
        className="share-card"
        src={`/api/card/${popNumber}.png`}
        width={1200}
        height={630}
        alt={`Share card showing pop number ${popNumber.toLocaleString("en-US")}`}
      />

      <div className="share-actions">
        <Link to="/" className="cta">
          {copy.share.cta}
        </Link>
        <button className="chip-wide" onClick={share}>
          {copied ? "Link copied" : "Share this card"}
        </button>
      </div>
    </main>
  );
}
